/**
 * API-обёртка глобального поиска CRM (DEV-303).
 *
 * HTTP: GET /api/v1/search (search-сервис через nginx).
 * Использует сгенерированный клиент (src/api/clients/search, регистрируется в @/api
 * как searchApi) и маппит DTO (V1*) в доменную модель. Authorization (Bearer) и
 * user-locale прокидываются интерсепторами общего apiClient централизованно.
 */
import { searchApi as searchServiceClient } from '@/api'
import type { V1SearchGroup, V1SearchHit } from '@/api/clients/search'
import type {
  GlobalSearchParams,
  GlobalSearchResponse,
  SearchEntityType,
  SearchHit,
} from '../types/search.types'

const mapHit = (h: V1SearchHit): SearchHit => ({
  type: (h.type ?? 'SEARCH_ENTITY_TYPE_INVALID') as SearchEntityType,
  entityId: h.entityId ?? '',
  title: h.title ?? '',
  subtitle: h.subtitle,
  score: h.score,
  route: h.route,
  meta: h.meta,
})

const mapGroup = (g: V1SearchGroup) => ({
  type: (g.type ?? 'SEARCH_ENTITY_TYPE_INVALID') as SearchEntityType,
  total: g.total ?? 0,
  hits: (g.hits ?? []).map(mapHit),
})

export const searchApi = {
  /**
   * Глобальный поиск по клиентам, сделкам и объектам.
   * @param params поисковый запрос и опциональные лимиты/типы
   * @param signal AbortSignal для отмены устаревших запросов при быстром наборе
   */
  async globalSearch(
    params: GlobalSearchParams,
    signal?: AbortSignal,
  ): Promise<GlobalSearchResponse> {
    const { data } = await searchServiceClient.searchServiceGlobalSearch(
      params.query,
      params.types,
      params.limitPerType,
      { signal },
    )
    return {
      groups: (data.groups ?? []).map(mapGroup),
      total: data.total ?? 0,
    }
  },
}
